import { mutator } from 'satcheljs';
import { getStore } from '../store/store';
import { calendarUpdated, Calendar } from 'owa-calendar-cache';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';

/**
 * updates calendars with appropriate cache changes
 */
mutator(calendarUpdated, msg => {
    const { calendarId, updates } = msg;
    let foundCalendarResult = findInArray(getStore().calendars, item => {
        return item.calculatedFolderId == calendarId;
    });

    if (foundCalendarResult) {
        const newCalendar: Calendar = {
            ...foundCalendarResult.item,
            ...updates,
        };

        getStore().calendars.splice(foundCalendarResult.index, 1, newCalendar);
    }
});
